import { UIElement } from '../ui-element';
import { Component } from '../../decorators/component.decorator';
import { setUnsafeInnerHTML } from '../../global/render-api';
import styles from './ui-described-control.css';

/**
 * @class
 * @memberof SharedComponents
 * @augments {UIElement}
 * @alias UIDescribedControl
 * @element ui-described-control
 * @classdesc Represents a class for <code>ui-described-control</code> element.
 * Control for visual presenting checkbox or radio label with inline ui-tooltip right after.
 * @slot
 * @example
 * <ui-described-control>
 *   <input type="checkbox" id="agree" />
 *   <label for="agree">I agree to terms</label>
 *   <ui-tooltip>More info about this option</ui-tooltip>
 * </ui-described-control>
 */
@Component({ tag: 'ui-described-control', styles })
export class UIDescribedControl extends UIElement {
    /**
     * @inheritDoc
     */
    override render(): void {
        const childNodes = this.detachChildNodes();
        const label = childNodes
            .filter((node) => node?.localName === 'label')
            .shift();

        if (label) {
            setUnsafeInnerHTML(label, label.innerHTML + '&zwj;');
        }

        this.updateElement({
            children: [
                {
                    tagName: 'span',
                    classList: {
                        'ui-described-control__target': true,
                    },
                    children: [
                        childNodes
                            .filter((node) => node?.localName === 'input')
                            .shift() as HTMLInputElement,
                        label as HTMLLabelElement,
                    ],
                },
                childNodes
                    .filter((node) => node?.localName === 'ui-tooltip')
                    .shift() as HTMLElement,
            ],
        });

        setUnsafeInnerHTML(this, this.innerHTML.replace(/>\s{2,}/gm, '>'));
    }
}
